import { createContext } from 'react';
import { ServicePage } from 'src/redux/apiTypes';

const ServicePagesContext = createContext<ServicePage[] | null>(null);

export default ServicePagesContext;
